import axios from "axios";

import { API_URL } from "./const";
import authHeader from "./authHeader";

class AuthService {
  login(username: string, password: string) {
    const credentials = { username: username, password: password };

    return axios.post(API_URL + "login", credentials);
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(
    username: string,
    password: string,
    role: string,
    isAccountNonExpired: number,
    isAccountNonLocked: number,
    isCredentialsNonExpired: number,
    isEnabled: number
  ) {
    return axios.post(API_URL + "register", {
      username,
      password,
      role,
      isAccountNonExpired,
      isAccountNonLocked,
      isCredentialsNonExpired,
      isEnabled,
    });
  }

  getUserRoles() {
    return axios.get(API_URL + "user/roles", {
      headers: authHeader(),
    });
  }
}

export default new AuthService();
